// GENERATED by scripts/build-icons.mjs from icons/link-2.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Link2 = createIcon('link-2', [
  ['path', { d: "M9 17H7A5 5 0 0 1 7 7h2" }],
  ['path', { d: "M15 7h2a5 5 0 1 1 0 10h-2" }],
  ['line', { x1: "8", x2: "16", y1: "12", y2: "12" }],
])
